// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {AlertBarMessageList} from './alert-bar-message-list';
import AlertMessage from '../../state/alert-message';
import {FormattedMessage} from 'react-intl';
import SuccessAlertBar from '../alert-bar/success-alert-bar';

const getDismissHandler = onDismiss =>
    () => {

        onDismiss('success');

    };

export const SuccessMessageContainer = props => {

    const title = props.successMessages.length > 1 ?
        <FormattedMessage id='SUCCESS_MESSAGES_TITLE'/> :
        <FormattedMessage id='SUCCESS_MESSAGE_TITLE'/>;

    const content = props.successMessages.length > 1 ? (
        <AlertBarMessageList messages={props.successMessages}/>
    ) :
    props.successMessages.length > 0 && props.successMessages[0].message;

    return (
        <div className='success-message-container'>
            <SuccessAlertBar
                alertTitle={title}
                dismissHandler={getDismissHandler(props.onDismiss)}
                willAutoDismiss={true}
            >
                {content}
            </SuccessAlertBar>
        </div>
    );

};

SuccessMessageContainer.displayName = 'SuccessMessageContainer';

SuccessMessageContainer.propTypes = {
    onDismiss: PropTypes.func.isRequired,
    successMessages: PropTypes.arrayOf(
        PropTypes.instanceOf(AlertMessage)
    ).isRequired
};



// WEBPACK FOOTER //
// ./src/shared/components/alert-bar-container/success-message-container.js